<template>
    <div
        class="relative shrink-0"
        :style="{ width: sizeInPx, height: sizeInPx }"
    >
        <VisSingleContainer
            :data="renderedSegments"
            :height="size"
            :width="size"
        >
            <VisDonut
                :value="(segment: DonutSegment) => segment.value"
                :color="(segment: DonutSegment) => segment.color"
                :arc-width="10"
                :pad-angle="0.02"
                :show-empty-segments="true"
            />
        </VisSingleContainer>
        <div
            class="pointer-events-none absolute inset-0 flex flex-col items-center justify-center text-center"
        >
            <slot />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { VisDonut, VisSingleContainer } from "@unovis/vue";

export interface DonutSegment {
    key: string;
    value: number;
    color: string;
}

const props = withDefaults(
    defineProps<{
        segments: DonutSegment[];
        size?: number;
    }>(),
    { size: 112 },
);

const EMPTY_SEGMENT_COLOR = "#e5e7eb";

const sizeInPx = computed<string>(() => `${props.size}px`);

const renderedSegments = computed<DonutSegment[]>(() => {
    const total = props.segments.reduce(
        (sum, segment) => sum + segment.value,
        0,
    );

    return total > 0
        ? props.segments
        : [{ key: "empty", value: 1, color: EMPTY_SEGMENT_COLOR }];
});
</script>
